import * as React from 'react'

const SvgRuler = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#ruler_svg__clip0)">
      <path
        d="M6.785 31.424a1.97 1.97 0 002.78 0l21.86-21.86a1.969 1.969 0 000-2.78L25.212.575a1.969 1.969 0 00-2.78 0l-.531.531 3.18 3.18a.983.983 0 01-1.389 1.39l-3.18-3.181-1.743 1.742 1.615 1.615a.983.983 0 01-1.389 1.389l-1.614-1.615-1.88 1.88 1.614 1.615a.983.983 0 01-1.388 1.389l-1.615-1.615-1.88 1.883 3.18 3.18a.982.982 0 01-1.389 1.39l-3.18-3.181-1.844 1.844 1.615 1.615a.982.982 0 01-1.389 1.388L7.61 15.401l-1.88 1.88 1.615 1.614a.982.982 0 01-1.389 1.39l-1.618-1.612-1.844 1.844 3.18 3.18a.983.983 0 01-1.388 1.389l-3.18-3.18-.531.53a1.969 1.969 0 000 2.78l6.21 6.208z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="ruler_svg__clip0">
        <path fill="currentColor" d="M0 0h32v32H0z" />
      </clipPath>
    </defs>
  </svg>
)

export default SvgRuler
